import React, { useMemo, useRef } from "react";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
} from "../../../../../../shared/helpers/utils";
import { parseEditedHTML } from "../../../exportreport/utils";

// Module-level counter to ensure unique ids when parent doesn't supply one
var __subHeaderInstanceCounter = 0;

const SubHeader = function (props) {
  props = props || {};
  var reportData = props.reportData;
  var subtext = props.subtext != null ? props.subtext : "COMPARABLE SALES REPORT";
  var editedContent = props.editedContent != null ? props.editedContent : "";
  var reportTitle = props.reportTitle;
  var dateDisplay = props.dateDisplay;
  var instanceKeyProp = props.instanceKey; // optional: parent can pass e.g. page index

  var buildingRes = reportData && reportData.buildingRes ? reportData.buildingRes : {};
  var compSettings = reportData && reportData.compSettings ? reportData.compSettings : {};

  var editedMap = useMemo(function () {
    return parseEditedHTML(editedContent);
  }, [editedContent]);

  // Stable per-instance id: prefer parent-provided, else allocate once
  var instanceIdRef = useRef(null);
  if (instanceIdRef.current === null) {
    if (instanceKeyProp !== undefined && instanceKeyProp !== null) {
      instanceIdRef.current = String(instanceKeyProp);
    } else {
      __subHeaderInstanceCounter += 1;
      instanceIdRef.current = String(__subHeaderInstanceCounter);
    }
  }

  // Build unique DOM id for this instance
  function ns(localId) {
    return instanceIdRef.current + "-" + localId;
  }

  // Look up shared edits: exact base id, then any key that ends with "-<base>"
  function findEditedKey(localId) {
    if (!editedMap) return null;
    if (editedMap[localId]) return localId;

    var suffix = "-" + localId;
    for (var k in editedMap) {
      if (!Object.prototype.hasOwnProperty.call(editedMap, k)) continue;
      if (k.length >= suffix.length && k.slice(-suffix.length) === suffix) {
        return k;
      }
    }
    return null;
  }

  function renderEditedOrDefault(localId, fallback) {
    var key = findEditedKey(localId);
    if (!key) return fallback;

    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(editedMap[key], "text/html");
      var el = doc.body.firstElementChild;
      if (el && el.getAttribute("data-changed") === "true") {
        return <div dangerouslySetInnerHTML={{ __html: el.outerHTML }} />;
      }
    } catch (e) {
      console.warn("Failed to parse edited HTML for id:", localId, e);
    }
    return fallback;
  }

  var neighborhood =
    buildingRes && buildingRes.neighborhood
      ? _capitalizeText(buildingRes.neighborhood) + ","
      : "";
  var borough =
    buildingRes && buildingRes.borough ? _capitalizeText(buildingRes.borough) : "";

  return (
    <div className="sub_header">
      {renderEditedOrDefault(
        "buildingLocation",
        <h3 id={ns("buildingLocation")} className="editable track-original building-location">
          {reportTitle}
        </h3>
      )}

      {renderEditedOrDefault(
        "headingLocation",
        <h3 id={ns("headingLocation")} className="header-text heading-location editable track-original">
          {(neighborhood + borough).toUpperCase()}
        </h3>
      )}

      <div className="date_comp">
        {renderEditedOrDefault(
          "subtext",
          <div id={ns("subtext")} className="editable track-original">
            {subtext}
          </div>
        )}
        <div></div>
        {renderEditedOrDefault(
          "formattedDate",
          <div id={ns("formattedDate")} className="editable track-original">
            {dateDisplay}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubHeader;
